import React, { ChangeEvent } from "react";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import IPrice_Group from "../../../models/IPrice_Group";
import { FormattedNumber } from "react-intl";
import styled from "styled-components";
import { NumericFormat } from "react-number-format";
import { isNil } from "lodash-es";
import OrderEntryService from "../../../services/OrderEntryService";

type Props = {
    row: IOrder_ItemUI;
    updatePriceGroupRowFn: (priceGroupId: number, row: IOrder_ItemUI) => void;
    priceGroups: IPrice_Group[];
};

export const OrderItemPriceGroupSelect = (props: Props) => {
    const [updatePriceGroupId, setUpdatePriceGroupId] = React.useState<number | null>(null);
    const [updatePriceGroupValue, setUpdatePriceGroupValue] = React.useState<IPrice_Group | null>(null);

    const handlePriceGroupChange = (e: ChangeEvent<any>) => {
        const priceGroupId = parseInt(e.target.value);
        setUpdatePriceGroupId(priceGroupId);

        if (props.row.Catalog_Item) {
            const priceGroup = props.priceGroups.find((pg) => pg.id === priceGroupId);
            if (priceGroup) {
                setUpdatePriceGroupValue(priceGroup);
            }
        }

        props.updatePriceGroupRowFn(priceGroupId, props.row);
    };

    return (
        <div className={"OrderItemPriceGroupSelect"}>
            <div>
                <OwSelectOption
                    fn={handlePriceGroupChange}
                    titleProp={"value"}
                    valueProp={"id"}
                    name={"price_group_id"}
                    options={props.priceGroups}
                    selectedOption={props.row}
                    selectedOptionProp={"price_group_id"}
                />
            </div>
            {/* a sum-priced kit's own pricing is ignored by the api - only preview its api-computed price */}
            {updatePriceGroupId &&
            updatePriceGroupValue &&
            (!OrderEntryService.isSumComponentPricedKit(props.row?.Catalog_Item) ||
                !isNil(props.row?.Catalog_Item?.kit_sum_pricing?.[updatePriceGroupValue.value])) ? (
                <NumberWrapper>
                    <NumericFormat
                        value={OrderEntryService.getCatalogItemPricingValue(props.row?.Catalog_Item, updatePriceGroupValue.value)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                    />
                    {/*<FormattedNumber*/}
                    {/*    value={props.row?.Catalog_Item?.pricing[updatePriceGroupValue.value]}*/}
                    {/*    currency={"USD"}*/}
                    {/*    minimumSignificantDigits={2}*/}
                    {/*    currencySign={"standard"}*/}
                    {/*/>*/}
                </NumberWrapper>
            ) : null}
        </div>
    );
};

const NumberWrapper = styled.div`
    padding: 0.25rem 0.5rem;
`;
